import * as React from "react";
import SectionHeading from "~/primitiveComponents/dataDisplay/Section/SectionHeading";
interface DataTableSectionHeadingProps {
    title: string;
}
export default function DataTableSectionHeading(props: DataTableSectionHeadingProps) {
    return <SectionHeading title={props.title}/>;
}
